import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./useQueryPlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./useQueryPlanEnrollments";
import { createPlanEnrollment } from "../../services/api/planEnrollment/createPlanEnrollment";
import { getRequirementsDependencies } from "../../modules/Requirements/dependencies";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentCreateRequest =
  planEnrollmentApiSpec.operations["enrollPlan"]["requestBody"]["content"]["application/json"];

/**
 * TODO(v3-blocker): there is no implemented v3 write that enrolls a contractor in
 * a Wingspan insurance plan, so this stays on the retired
 * `POST /v2/plan-enrollment` and throws `NotMigrated`.
 *
 * `POST /v3/platform/benefit-enrollments` and `POST /v3/platform/purchases` are
 * the designed replacements, but both resources answer 501 `NotImplemented` on
 * integration (see the read hook for the full list of 501 candidates). Until one
 * is built, the enroll flows can render but can never submit.
 */
export const useMutationCreatePlanEnrollment = (
  config?: WSMutationsConfig<
    IPlanEnrollment,
    WSServiceError,
    IPlanEnrollmentCreateRequest
  >
) =>
  useWSMutation(
    (request: IPlanEnrollmentCreateRequest) => createPlanEnrollment(request),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        ...getRequirementsDependencies()
      ],
      ...config
    }
  );
